/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SetStatusesResponse
 */
export interface SetStatusesResponse {
  /**
   *
   * @type {Array<string>}
   * @memberof SetStatusesResponse
   */
  noteIds: Array<string>;
}

/**
 * Check if a given object implements the SetStatusesResponse interface.
 */
export function instanceOfSetStatusesResponse(
  value: object,
): value is SetStatusesResponse {
  if (!("noteIds" in value) || value["noteIds"] === undefined) return false;
  return true;
}

export function SetStatusesResponseFromJSON(json: any): SetStatusesResponse {
  return SetStatusesResponseFromJSONTyped(json, false);
}

export function SetStatusesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SetStatusesResponse {
  if (json == null) {
    return json;
  }
  return {
    noteIds: json["noteIds"],
  };
}

export function SetStatusesResponseToJSON(json: any): SetStatusesResponse {
  return SetStatusesResponseToJSONTyped(json, false);
}

export function SetStatusesResponseToJSONTyped(
  value?: SetStatusesResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    noteIds: value["noteIds"],
  };
}
